module.exports = __webpack_public_path__ + "img/logo-client.28e89f86.svg";